import moment from 'moment';

import { Colors } from '../../utils/enums/colors';
import { dates } from '../../utils/helpers/loadGameAssets';

export class UIController {
  static centerXY(context: Phaser.Scene): [number, number] {
    const { width, height } = context.game.canvas;
    return [width / 2, height / 2];
  }

  static widthHeight(context: Phaser.Scene): [number, number] {
    const { width, height } = context.game.canvas;
    return [width, height];
  }

  static textColor(): string {
    const now = moment();
    return dates.programmers.isSame(now, 'day') ? Colors.WHITE : Colors.BLACK;
  }
}
